var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOval00AError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 80 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  d: "M50 17c7.18 0 13 5.82 13 13s-5.82 13-13 13H30c-7.18 0-13-5.82-13-13s5.82-13 13-13h20Z"
})));
SvgOval00AError.viewBox = '0 0 80 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgOval00AError);
export default ForwardRef;